export default "__VITE_ASSET__Cwqxg2Ql__"